import EditorJS from '@editorjs/editorjs';
import debounce from 'debounce';
import { Dispatch } from 'redux';
import { InstructionEvent } from '../../../../components/script-editor/tools/types';
import { setEditingScript, setSavedScript, setSavingScript } from '../../../../store/modules/scenes/actions';

export default class KeyUpHandler {
  private delay = 5000;

  private debounceSubmit: ReturnType<typeof debounce> ;

  constructor(private editor:EditorJS, private dispatch: Dispatch) {
    this.debounceSubmit = debounce(() => this.editor.emit(InstructionEvent.SUBMIT_DATA, {}), this.delay);
  }

  process() {
    this.debounceSubmit();
    this.dispatch(setEditingScript(true));
    this.dispatch(setSavingScript(false));
    this.dispatch(setSavedScript(false));
  }
}
